export default __webpack_public_path__ + "ecb76ef5be9dcc60f3dc87b2960c031f.ttf";